import Typography from '@components/common/typography';
import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';
import InfoBlock from '@components/common/info_block';
import useModalContext from '@hooks/context/useModalContext';

const FreezeCardModal = () => {
    return (
        <div className={styles.wrapper}>
            <Typography className={styles.title} variant="h4">
                Freeze card
            </Typography>
            <Typography variant="body3" className={styles.description}>
                Are you sure you want to freeze your card? You can unfreeze it at any time.
            </Typography>
            <InfoBlock variant="warning">
                Please note: All in-store, online, and ATM transactions will be declined while your
                card is frozen. Any pending or scheduled payments you’ve set up for this card will
                also be paused.
            </InfoBlock>
        </div>
    );
};

export default FreezeCardModal;
